import { ThemeUICSSObject, spacing } from '@apia/theme';
/* IMPORT HERE */

const buttons: ThemeUICSSObject = {
  display: 'flex',
  justifyContent: 'end',
  gap: spacing(3),

  'button.toggled': {
    variant: 'buttons.primary',
  },
  /* PREPEND HERE */
};

export default buttons;
